import request from '@/utils/request'
//=================系统菜单====start===================//
// 系统菜单list
export function getMenuList(data) {
  return request({
    url: '/menu/list',
    method: 'post',
    data
  })
}

// 新增系统菜单
export function addMenu(data) {
  return request({
    url: '/menu/add',
    method: 'post',
    data
  })
}

// 修改系统菜单
export function editMenu(data) {
  return request({
    url: '/menu/update',
    method: 'post',
    data
  })
}

// 删除系统分类
export function deleteMenu(data) {
  return request({
    url: '/menu/delete',
    method: 'post',
    data
  })
}

// 获取系统菜单详情
export function getMenuDetail(data) {
  return request({
    url: '/menu/detail',
    method: 'post',
    data
  })
}

//=================角色权限====start===================//
// 角色list
export function getRoleList(data) {
  return request({
    url: '/role/list',
    method: 'post',
    data
  })
}

// 添加角色
export function addRole(data) {
  return request({
    url: '/role/add',
    method: 'post',
    data
  })
}

// 新增岗位-菜单权限列表
export function getRegisterMenuList(data) {
  return request({
    url: '/role/add/menuList',
    method: 'post',
    data
  })
}

// 新增岗位-按选择的商户获取菜单权限列表
export function getShopRegisterMenuList(data) {
  return request({
    url: '/role/add/shopMenuList',
    method: 'post',
    data
  })
}

// 新增岗位(管理台按选择商户)
export function addShopRole(data) {
  return request({
    url: '/role/addShopRole',
    method: 'post',
    data
  })
}

// 删除角色
export function deleteRole(data) {
  return request({
    url: '/role/delete',
    method: 'post',
    data
  })
}

// 获取角色权限
export function queryRolePermission(data) {
  return request({
    url: '/role/query',
    method: 'post',
    data
  })
}

// 分配角色权限
export function assignRolePermission(data) {
  return request({
    url: '/menu/role/relevance',
    method: 'post',
    data
  })
}

//=================平台操作员====start===================//
// 平台操作员list
export function getPlatformList(data) {
  return request({
    url: '/platform/manage/list',
    method: 'post',
    data
  })
}
export function getRolePlatformList(data) {
  return request({
    url: '/role/platform/list',
    method: 'post',
    data
  })
}

// 平台操作员add
export function addPlatformOperator(data) {
  return request({
    url: '/platform/manage/add',
    method: 'post',
    data
  })
}

// 平台操作员 edit
export function editPlatformOperator(data) {
  return request({
    url: '/platform/manage/modify',
    method: 'post',
    data
  })
}


// 平台操作员 delete
export function deletePlatformOperator(data) {
  return request({
    url: '/platform/manage/delete',
    method: 'post',
    data
  })
}


// 平台操作员 detail
export function getPlatformOperatorDetail(data) {
  return request({
    url: '/platform/manage/detail',
    method: 'post',
    data
  })
}

// 拉黑平台操作员 defriend
export function defriendPlatformOperator(data) {
  return request({
    url: '/platform/manage/defriend',
    method: 'post',
    data
  })
}


// 启用平台操作员 enab
export function enabPlatformOperator(data) {
  return request({
    url: '/platform/manage/enab',
    method: 'post',
    data
  })
}

// 锁定平台操作员 forbidden
export function forbiddenPlatformOperator(data) {
  return request({
    url: '/platform/manage/forbidden',
    method: 'post',
    data
  })
}


// 重置密码 reset
export function resetOperatorPassword(data) {
  return request({
    url: '/manage/password/rest',
    method: 'post',
    data
  })
}

// 修改密码(管理台代员工修改) manage/shopAdmin/updatePassword
export function updateMngShopAdminPwd(data) {
  return request({
    url: '/manage/shopAdmin/updatePassword',
    method: 'post',
    data
  })
}

// 理事授权详情
export function councilSet(data) {
  return request({
    url: 'platform/manage/council/set',
    method: 'post',
    data
  })
}
// 理事授权更新
export function councilUpdate(data) {
  return request({
    url: 'platform/manage/council/update',
    method: 'post',
    data
  })
}
//=================系统配置项====start===================//
// 系统配置list
export function configList(data) {
  return request({
    url: '/config/list',
    method: 'post',
    data
  })
}
// 系统配置get
export function configGet(data) {
  return request({
    url: '/config/get',
    method: 'post',
    data
  })
}
// 系统配置update
export function configUpdate(data) {
  return request({
    url: '/config/update/byCode',
    method: 'post',
    data
  })
}

//=================物流方管理====start===================//
// 物流方list
export function getLogisticsList(data) {
  return request({
    url: '/logistics/findLogistics',
    method: 'post',
    data
  })
}

// 物流方detail
export function getLogisticsDetail(data) {
  return request({
    url: '/logistics/detail',
    method: 'post',
    data
  })
}

// 物流方add
export function addLogisticsManager(data) {
  return request({
    url: '/logistics/addLogistics',
    method: 'post',
    data
  })
}

// 物流方编辑
export function editLogisticsManager(data) {
  return request({
    url: '/logistics/edit',
    method: 'post',
    data
  })
}

// 物流方禁用启用
export function disableEnableAction(data) {
  return request({
    url: '/logistics/enable',
    method: 'post',
    data
  })
}

//=================特殊商品结算====start===================//
export function getSpecialList(data) {
  return request({
    url: '/payment/settle/list',
    method: 'post',
    data
  })
}

export function getSpecialDetail(data) {
  return request({
    url: '/payment/settle/detail',
    method: 'post',
    data
  })
}

export function addSpecial(data) {
  return request({
    url: '/payment/settle/save',
    method: 'post',
    data
  })
}

export function delSpecial(data) {
  return request({
    url: '/payment/settle/delete',
    method: 'post',
    data
  })
}

// 没有该接口
export function editSpecial(data) {
  return request({
    url: '/special/edit',
    method: 'post',
    data
  })
}

export function disableSpecial(data) {
  return request({
    url: '/payment/settle/disable',
    method: 'post',
    data
  })
}

export function enableSpecial(data) {
  return request({
    url: '/payment/settle/enable',
    method: 'post',
    data
  })
}


//=================系统配置项====start===================//
// 白名单列表
export function whiteList(data) {
  return request({
    url: '/user/white/list',
    method: 'post',
    data
  })
}
// 白名单新增
export function whiteAdd(data) {
  return request({
    url: '/user/white/add',
    method: 'post',
    data
  })
}
// 消息列表
export function msgList(data) {
  return request({
    url: '/notify/configMsg/list',
    method: 'post',
    data
  })
}
// 消息新增
export function msgAdd(data) {
  return request({
    url: '/notify/configMsg/add',
    method: 'post',
    data
  })
}
// 消息更新状态
export function msgUpdate(data) {
  return request({
    url: '/notify/configMsg/update',
    method: 'post',
    data
  })
}

// ============================买家售后原因配置接口=============================
// 新增
export function addAfterReason(data) {
  return request({
    url: '/afterSale/addAfterReason',
    method: 'post',
    data
  })
}
export function getAfterReasonList(data) {
  return request({
    url: '/afterSale/getAfterReasonList',
    method: 'post',
    data
  })
}
// 列表
export function removeAfterReason(data) {
  return request({
    url: '/afterSale/removeAfterReason',
    method: 'post',
    data
  })
}
// 更新
export function updateAfterReason(data) {
  return request({
    url: '/afterSale/updateAfterReason',
    method: 'post',
    data
  })
}

// ============================业务配置接口=============================

// 列表
export function getSysConfigList(data) {
  return request({
    url: '/sysConfig/list',
    method: 'post',
    data
  })
}

// 更新
export function updateSysConfig(data) {
  return request({
    url: '/sysConfig/update',
    method: 'post',
    data
  })
}

// import { sysconfigList, sysconfigUpdate } from "@/api/system";
// ======================商户待入库====================
export function productShopList(data) {
  return request({
    url: 'product/shop/list',
    method: 'post',
    data
  })
}
export function productShopCate(data) {
  return request({
    url: 'product/shop/cate',
    method: 'post',
    data
  })
}
export function productPutaway(data) {
  return request({
    url: 'product/putaway',
    method: 'post',
    data
  })
}
export function productDisable(data) {
  return request({
    url: 'product/disable',
    method: 'post',
    data
  })
}
export function productRemove(data) {
  return request({
    url: 'product/remove',
    method: 'post',
    data
  })
}
export function productEnable(data) {
  return request({
    url: 'product/enable',
    method: 'post',
    data
  })
}
export function productSaveList(data) {
  return request({
    url: 'product/save/list',
    method: 'post',
    data
  })
}

// 定时器补偿
export function delayList(data) {
  return request({
    url: 'delay/list',
    method: 'post',
    data
  })
}
export function delayUpdate(data) {
  return request({
    url: 'delay/update',
    method: 'post',
    data
  })
}

// 忽略事件
export function delayFinish(data) {
  return request({
    url: 'delay/finish',
    method: 'post',
    data
  })
}

// 查询业务状态
export function businessStatus(data) {
  return request({
    url: 'delay/business/status',
    method: 'post',
    data
  })
}
/**
 * 补打原因配置
 */
// 补打原因列表
export function configReasonList(data) {
  return request({
    url: 'config/reason/page/list',
    method: 'post',
    data
  })
}
// 新增补打原因
export function configReasonAdd(data) {
  return request({
    url: 'config/reason/add',
    method: 'post',
    data
  })
}
// 修改补打原因
export function configReasonUpdate(data) {
  return request({
    url: 'config/reason/update',
    method: 'post',
    data
  })
}
// 删除补打原因
export function configReasonDel(data) {
  return request({
    url: 'config/reason/del',
    method: 'post',
    data
  })
}
/**
 * 杂项配置
 */
// 列表
export function configSundryList(data) {
  return request({
    url: 'config/sundryList',
    method: 'post',
    data
  })
}
export function enableSundryList(data) {
  return request({
    url: 'config/enableSundryList',
    method: 'post',
    data
  })
}
// 添加
export function configSundryAdd(data) {
  return request({
    url: 'config/sundryAdd',
    method: 'post',
    data
  })
}
// 变更状态
export function configSundryUpdate(data) {
  return request({
    url: 'config/sundryUpdate',
    method: 'post',
    data
  })
}

// 平台理事添加商户管理
export function councilShopAdd(data) {
  return request({
    url: '/platform/manage/council/shop/add',
    method: 'post',
    data
  })
}

// 采小助配置管理
export function cxzAdd(data) {
  return request({
    url: '/sysConfig/cxzAdd',
    method: 'post',
    data
  })
}
export function cxzList(data) {
  return request({
    url: '/sysConfig/cxzList',
    method: 'post',
    data
  })
}

export function getExport(data) {
  return request({ url: '/platform/manage/list/export', method: 'post', data, responseType: 'arraybuffer' })
}
/*-------------标签管理---------------------*/
//标签列表
export function getTagList(data) {
  return request({
    url: '/tag/queryPageList',
    method: 'post',
    data
  })
}
//嵌套添加标签
export function addTagNest(data) {
  return request({
    url: '/tag/addTagNest',
    method: 'post',
    data
  })
}
//单个添加标签
export function addTag(data) {
  return request({
    url: '/tag/addTag',
    method: 'post',
    data
  })
}
//操作(启用/禁用)
export function doOperate(data) {
  return request({
    url: '/tag/doOperate',
    method: 'post',
    data
  })
}
//删除标签
export function delTag(data) {
  return request({
    url: '/tag/deleteTag',
    method: 'post',
    data
  })
}
//新增标签
export function editTag(data) {
  return request({
    url: '/tag/updateTag',
    method: 'post',
    data
  })
}
/*---------------配送管理-----------------------*/
//仓库列表
export function getWarehouseList(data) {
  return request({
    url: '/warehouse/list',
    method: 'post',
    data
  })
}
//仓库详情信息
export function getWarehouseDetail(data) {
  return request({
    url: '/warehouse/configList',
    method: 'post',
    data
  })
}
// 保存区域配置
export function saveWareHouseDetail(data) {
  return request({
    url: '/warehouse/wareHouseDistancePriceAdd',
    method: 'post',
    data
  })
}



//出门扫码商品问题配置 列表
export function getPdaIssues(data) {
  return request({
    url: '/pda/issue/list',
    method: 'post',
    data
  })
}

//出门扫码商品问题配置 新增
export function addPdaIssues(data) {
  return request({
    url: '/pda/issue/create',
    method: 'post',
    data
  })
}

//出门扫码商品问题配置 删除
export function delPdaIssues(data) {
  return request({
    url: '/pda/issue/delete',
    method: 'post',
    data
  })
}

//出门扫码商品问题配置 修改
export function editPdaIssues(data) {
  return request({
    url: '/pda/issue/edit',
    method: 'post',
    data
  })
}

// 重点商户商品配置  商户查询
export function getKeyShopList(data) {
  return request({
    url: '/pda/keyshop/list',
    method: 'post',
    data
  })
}
// 重点商户商品配置  分类查询
export function getKeyProList(data) {
  return request({
    url: '/pda/keyproduct/list',
    method: 'post',
    data
  })
}
// 重点商户商品配置  商户更新
export function submitKeyShopList(data) {
  return request({
    url: '/pda/keyshop/update',
    method: 'post',
    data
  })
}
// 重点商户商品配置  分类更新
export function submitKeyProList(data) {
  return request({
    url: '/pda/keyproduct/update',
    method: 'post',
    data
  })
}
/*---------------市场行情配置---------------*/
//新增品类
export function addCateSettings(data) {
  return request({
    url: '/priceCategorySetting/addPriceCategorySettings',
    method: 'post',
    data
  })
}

//修改品类统计
export function editCateSettings(data) {
  return request({
    url: '/priceCategorySetting/updatePriceCategorySettings',
    method: 'post',
    data
  })
}
//热门行情配置
export function getHotSettings(data) {
  return request({
    url: '/priceHotCategorySetting/getPriceHotCategorySettings',
    method: 'post',
    data
  })
}
//热门行情配置 排序
export function changeSort(data) {
  return request({
    url: '/priceHotCategorySetting/sortHotPriceCategorySetting',
    method: 'post',
    data
  })
}
//热门行情配置 禁用启用
export function changeSettingStatus(data) {
  return request({
    url: '/priceHotCategorySetting/updateHotPriceCategorySetting',
    method: 'post',
    data
  })
}
//热门行情配置 删除
export function delHotSetting(data) {
  return request({
    url: '/priceHotCategorySetting/deleteHotPriceCategorySetting',
    method: 'post',
    data
  })
}
//热门行情配置 新增中获取所有品类
export function getPriceCateSetting(data) {
  return request({
    url: '/priceCategorySetting/getPriceCategoryUnitSettings',
    method: 'post',
    data
  })
}
//热门行情配置 新增品类/添加到热门
export function addHotCateSetting(data) {
  return request({
    url: '/priceHotCategorySetting/addPriceHotCategorySetting',
    method: 'post',
    data
  })
}
// 市场行情配置列表
export function getMarketSettings(data) {
  return request({
    url: '/priceCategorySetting/querySaleInfo',
    method: 'post',
    data
  })
}

// 市场行情 发布
export function publishMarketSettings(data) {
  return request({
    url: '/priceCategorySetting/publish',
    method: 'post',
    data
  })
}
// 市场行情 取消发布
export function unPublish(data) {
  return request({
    url: '/priceCategorySetting/unPublish',
    method: 'post',
    data
  })
}
// 市场行情 一键发货
export function batchPublish(data) {
  return request({
    url: '/priceCategorySetting/publishAll',
    method: 'post',
    data
  })
}
// 市场行情 修改展示名
export function editDisplayName(data) {
  return request({
    url: '/priceCategorySetting/updateDisplayName',
    method: 'post',
    data
  })
}
// 市场行情 修改展示价格
export function editDisplayPrice(data) {
  return request({
    url: '/priceCategorySetting/updatePlayPrice',
    method: 'post',
    data
  })
}
// 市场行情 获取价格趋势
export function getPriceTrend(data) {
  return request({
    url: '/priceCategorySetting/getPriceTrend',
    method: 'post',
    data
  })
}

// 市场行情 修改价格趋势
export function editPriceTrend(data) {
  return request({
    url: '/priceCategorySetting/updatePriceTrend',
    method: 'post',
    data
  })
}
// 市场行情 取消热门
export function cancelHotSetting(data) {
  return request({
    url: '/priceHotCategorySetting/quXiaoHotPriceCategorySetting',
    method: 'post',
    data
  })
}
// 市场行情 获取商户数据
export function getProShopList(data) {
  return request({
    url: '/priceCategorySetting/onlineProductSettingList',
    method: 'post',
    data
  })
}
// 市场行情 操作商户展不展示
export function displayShop(data) {
  return request({
    url: '/priceCategorySetting/onlineProductSetting',
    method: 'post',
    data
  })
}
// 市场行情 导出
export function expoerMarketSetting(data) {
  return request({
    url: '/priceCategorySetting/querySaleInfoExport',
    method: 'post',
    data,
    responseType: 'arraybuffer'
  })
}
// 市场行情 导入
export function importData(data) {
  return request({
    url: '/priceCategorySetting/querySaleInfoImport',
    method: 'post',
    data
  })
}
// 市场行情 删除分类
export function deleteCateSettings(data) {
  return request({
    url: '/priceCategorySetting/delPriceCategorySettings',
    method: 'post',
    data
  })
}

//=================员工管理(管理台)====start===================//
// 员工管理list
export function getMngShopAdminList(data) {
  return request({
    url: '/manage/shopAdmin/list',
    method: 'post',
    data
  })
}
// 员工管理 店铺角色列表
export function getMngShopAdminRoleList(data) {
  return request({
    url: '/manage/shopAdmin/roleList',
    method: 'post',
    data
  })
}
// 员工管理add
export function addMngShopAdmin(data) {
  return request({
    url: '/manage/shopAdmin/add',
    method: 'post',
    data
  })
}
// 员工管理 detail
export function getMngShopAdminDetail(data) {
  return request({
    url: '/manage/shopAdmin/detail',
    method: 'post',
    data
  })
}
// 员工管理 edit
export function editMngShopAdmin(data) {
  return request({
    url: '/manage/shopAdmin/modify',
    method: 'post',
    data
  })
}
// 员工管理 禁用
export function forbiddenMngShopAdmin(data) {
  return request({
    url: '/manage/shopAdmin/forbidden',
    method: 'post',
    data
  })
}
// 员工管理 启用
export function enabMngShopAdmin(data) {
  return request({
    url: '/manage/shopAdmin/enab',
    method: 'post',
    data
  })
}
// 员工管理 拉黑
export function defriendMngShopAdmin(data) {
  return request({
    url: '/manage/shopAdmin/defriend',
    method: 'post',
    data
  })
}
// 员工管理 删除
export function deleteMngShopAdmin(data) {
  return request({
    url: '/manage/shopAdmin/delete',
    method: 'post',
    data
  })
}
// 发送短信验证码
export function mngSmsSend(data) {
  return request({
    url: '/sms/send',
    method: 'post',
    data
  })
}






// WEBPACK FOOTER //
// ./src/api/system.js